import React, { Component } from 'react';
import '../css/locationSearchInput.css';

import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';

const CITY_PRESETS = [
  { code: 'UIO', label: 'Quito', center: { lat: -0.1806532, lng: -78.4678382 }, radius: 25000 },
  { code: 'UIO-CB', label: 'Quito - Cumbayá', center: { lat: -0.196268, lng: -78.440668 }, radius: 18000 },
  { code: 'UIO-VLL', label: 'Quito - Los Valles', center: { lat: -0.330000, lng: -78.420000 }, radius: 25000 },
  { code: 'GYE', label: 'Guayaquil', center: { lat: -2.1709979, lng: -79.9223592 }, radius: 25000 },
  { code: 'SAM', label: 'Samborondón', center: { lat: -1.936530, lng: -79.836710 }, radius: 15000 },
  { code: 'DAU', label: 'Daule', center: { lat: -1.861680, lng: -79.958650 }, radius: 15000 },
];

const ADDRESS_TYPES = [
  { value: 'domicilio', label: 'Domicilio' },
  { value: 'oficina', label: 'Oficina' },
  { value: 'local_comercial', label: 'Local comercial' },
];

const DEFAULTS = {
  direccion1: '',
  direccion2: '',
  address: '',
  cityCode: '',
  forceCityBounds: true,
  addressType: 'domicilio',
  viviendaType: 'casa',
  reference: '',
  aptOrFloor: '',
  sector: '',
  entregaModo: 'encuentro',
  entregaFecha: '',
  entregaHora: '',
  urbanizacion: '',
  etapa: '',
  manzana: '',
  villa: '',
  nombreContacto: '',
  telefonoContacto: '',
};

class locationSearchInput extends Component {
  constructor(props) {
    super(props);

    this.autocompleteRef = null;

    this.state = {
      ...DEFAULTS,
      ...(props.data?.cityCode ? props.data : {}),
      loadingGeo: false,
      selectedPlace: null,
      errorMsg: '',
      isFocused: false,
      citySelected: false,
      telefonoInvalido: false, 
    };
  }

  componentDidMount() {
    const hasParentData = !!this.props.data && Object.keys(this.props.data).length > 0;
    if (!hasParentData) {
      const saved = localStorage.getItem("locationData");
      //console.log(saved)
      if (saved) {
        const parsed = JSON.parse(saved);

        // SOLO restauro la ciudad si parsed.cityCode existe Y NO está vacío
        if (parsed.cityCode && parsed.cityCode !== '') {
          this.setState({ ...DEFAULTS, ...parsed, citySelected: true });
        }
      }
    }
  }

  handleSave = () => {
    if (this.props.onSave) {
      this.props.onSave(this.state);
    }
  };

  getSelectedCityPreset = () => {
    return CITY_PRESETS.find(c => c.code === this.state.cityCode) || null;
  };

  getSearchOptions = () => {
    const base = { componentRestrictions: { country: 'ec' } };

    if (this.state.forceCityBounds && window.google && window.google.maps && this.state.cityCode) {
      const preset = this.getSelectedCityPreset();
      if (!preset) return base;

      const location = new window.google.maps.LatLng(preset.center.lat, preset.center.lng);
      return { ...base, location, radius: preset.radius };
    }

    return base;
  };

  letterCount = (str = '') => {
    const m = (str || '').match(/[A-Za-zÁÉÍÓÚÜÑáéíóúü]/g);
    return m ? m.length : 0;
  };

  buildCompositeAddress = (d1, d2) => {
    const direccion1 = d1 !== undefined ? d1 : this.state.direccion1;
    const direccion2 = d2 !== undefined ? d2 : this.state.direccion2;
    const parts = [direccion1, direccion2].filter(Boolean);
    return parts.join(' y ').replace(/\s+/g, ' ').trim();
  };

  getfullText = () => {
    const { selectedPlace, cityCode } = this.state;
    if (!selectedPlace) return;

    const city = this.getSelectedCityPreset();

    const lines = [
      `Ciudad: ${city ? city.label : ''}`,
      `Dirección1: ${this.state.direccion1}`,
      `Dirección2: ${this.state.direccion2}`,
    ];

    // 🔥 SOLO PARA GUAYAQUIL
    if (cityCode === 'GYE') {
      if (this.state.urbanizacion) lines.push(`Urbanización: ${this.state.urbanizacion}`);
      if (this.state.etapa) lines.push(`Etapa: ${this.state.etapa}`);
      if (this.state.manzana) lines.push(`Manzana: ${this.state.manzana}`);
      if (this.state.villa) lines.push(`Villa: ${this.state.villa}`);
    }

    // 🔥 Sector solo si NO es edificio (ya lo tienes así en el formulario)
    if (this.state.viviendaType !== 'edificio') {
      if (this.state.sector) lines.push(`Sector/Urbanización: ${this.state.sector}`);
    }

    // 🔥 Solo para edificio
    if (this.state.viviendaType === 'edificio' && this.state.aptOrFloor) {
      lines.push(`Depto/Piso: ${this.state.aptOrFloor}`);
    }

    // Siempre visibles
    if (this.state.reference) lines.push(`Referencia: ${this.state.reference}`);
    if (this.state.nombreContacto) lines.push(`Contacto: ${this.state.nombreContacto}`);
    if (this.state.telefonoContacto) lines.push(`Tel: ${this.state.telefonoContacto}`);

    return lines.join(' | ');
  };

  emitPayload = () => {
    const { selectedPlace, cityCode } = this.state;
    if (!selectedPlace) return;

    const city = this.getSelectedCityPreset();

    // Construimos el texto final igual que getfullText()
    const lines = [
      `Ciudad: ${city ? city.label : ''}`,
      `Dirección1: ${this.state.direccion1}`,
      `Dirección2: ${this.state.direccion2}`,
    ];

    // 🔥 SOLO PARA GUAYAQUIL
    if (cityCode === 'GYE') {
      if (this.state.urbanizacion) lines.push(`Urbanización: ${this.state.urbanizacion}`);
      if (this.state.etapa) lines.push(`Etapa: ${this.state.etapa}`);
      if (this.state.manzana) lines.push(`Manzana: ${this.state.manzana}`);
      if (this.state.villa) lines.push(`Villa: ${this.state.villa}`);
    }

    // 🔥 Sector solo si NO es edificio
    if (this.state.viviendaType !== 'edificio') {
      if (this.state.sector) lines.push(`Sector/Urbanización: ${this.state.sector}`);
    }

    // 🔥 Para edificio
    if (this.state.viviendaType === 'edificio' && this.state.aptOrFloor) {
      lines.push(`Depto/Piso: ${this.state.aptOrFloor}`);
    }

    // 🔥 Siempre visibles
    if (this.state.reference) lines.push(`Referencia: ${this.state.reference}`);
    if (this.state.nombreContacto) lines.push(`Contacto: ${this.state.nombreContacto}`);
    if (this.state.telefonoContacto) lines.push(`Tel: ${this.state.telefonoContacto}`);

    const fullText = lines.join(' | ');

    // 📦 Payload FINAL que enviamos al backend / paso siguiente
    const payload = {
      rawAddress: this.state.address,
      formattedAddress: selectedPlace.formatted_address,
      lat: selectedPlace.latLng.lat,
      lng: selectedPlace.latLng.lng,
      city: city ? city.label : '',
      cityCode,
      addressType: this.state.addressType,
      viviendaType: this.state.viviendaType,
      reference: this.state.reference,
      aptOrFloor: this.state.aptOrFloor,
      sector: this.state.viviendaType !== "edificio" ? this.state.sector : "",
      direccion1: this.state.direccion1,
      direccion2: this.state.direccion2,
      nombreContacto: this.state.nombreContacto,
      telefonoContacto: this.state.telefonoContacto,
      timestamp: new Date().toISOString(),
    };

    // 🔥 SOLO poner estos campos si ciudad = GUAYAQUIL
    if (cityCode === "GYE") {
      payload.urbanizacion = this.state.urbanizacion;
      payload.etapa = this.state.etapa;
      payload.manzana = this.state.manzana;
      payload.villa = this.state.villa;
    }

    if (this.props.onConfirm) {
      this.props.onConfirm(payload);
    }

    if (window) alert(fullText);
  };

  getStepNewUbication = (latLng, name, reference) => {

    const database= this.props.database
    if(database!=='bd_app_5esquinas'&&database!=='bd_app_eldt'){
      const required = [
        'direccion1',
        'direccion2',
        'reference',
        'nombreContacto',
        'telefonoContacto'
      ];

      if (this.state.cityCode === 'GYE') {
        required.push('urbanizacion', 'etapa', 'manzana', 'villa');
      }

      for (let f of required) {
        if (!this.state[f] || this.state[f].trim() === '') {
          alert(`El campo ${f.toUpperCase()} es obligatorio.`);
          return;
        }
      }

      const regex = /^09\d{8}$/;
      if (!regex.test(this.state.telefonoContacto)) {
        alert('Debe ingresar un celular válido de Ecuador (09xxxxxxxx)');
        return;
      }
  }

    if (this.props.get_go_to) {
      this.handleSave();
      this.props.get_go_to('StepNewUbication', latLng.lat, latLng.lng, name, reference);
    }
  };

  handleChange = (address) => {
    this.setState({
      address,
      errorMsg: '',
      selectedPlace: null,
      isFocused: true,
    });
  };

  getUbicacion = (result) => {
    return getLatLng(result)
      .then((latLng) => {
        this.setState({
          selectedPlace: { latLng, formatted_address: result.formatted_address }
        }, () => {
          this.getStepNewUbication(latLng, this.getfullText(), this.state.reference);
        });

        return { latLng, formatted_address: result.formatted_address };
      })
      .catch(() => {
        this.setState({ errorMsg: 'No se pudo obtener lat/lng de la dirección seleccionada.' });
        return null;
      });
  };

  handleSelect = (address) => {
    this.setState({ address, errorMsg: '' });

    geocodeByAddress(address)
      .then((results) => this.getUbicacion(results[0]))
      .catch(() => {
        this.setState({ errorMsg: 'No se pudo geocodificar la dirección.' });
      });
  };

  handleInputFocus = () => this.setState({ isFocused: true });

  handleInputBlur = () => {
    this.setState(prev => ({
      isFocused: false,
      address: (prev.address || '').trim()
    }));
  };

  handleClear = () => {
    this.setState({ address: '', selectedPlace: null, errorMsg: '' });
  };

  render() {
    const { address, forceCityBounds, errorMsg, citySelected } = this.state;
    const searchOptions = this.getSearchOptions();
    const shouldFetch = this.letterCount(address) >= 7;
    console.log(this.state.cityCode)
    return (
      <React.Fragment>
        <br/><br/><br/><br/><br/>

        <div className="modal-dialog-find-ubication">
          <div className="modal-body-scroll">
          <div className="modal-content-find-ubication">

            <div className="grid-container-menu-find-ubication">
              <div className="div_menu_1-find-ubication">
                <img
                  className="icon-global"
                  src={require('../image/12355707351582004488-128.png')}
                  onClick={() => this.props.get_go_to_step && this.props.get_go_to_step('ubicacion')}
                />
              </div>
              <div className="lbl_menu_2-find-ubication">
                <span className="span-global-link">Ingrese su Ubicación</span>
              </div>
            </div>
            
            {/* === FILA 1 === */}
            <div className="cc-filters">
              
              {/* Selección de Ciudad */}
              <div className="cc-field">
                <label>Ciudad</label>
                <select
                  className="cc-input"
                  value={this.state.cityCode || ""}
                  onChange={(e) =>
                    this.setState(
                      {
                        cityCode: e.target.value,
                        citySelected: e.target.value !== ""
                      },
                      () => {
                        const composite = this.buildCompositeAddress();
                        if (composite) this.setState({ address: composite });
                      }
                    )
                  }
                >
                  <option value="">Seleccione una ciudad</option>
                  {CITY_PRESETS.map((c) => (
                    <option key={c.code} value={c.code}>{c.label}</option>
                  ))}
                </select>
              </div>

              {/* Forzar límites */}
              <div className="cc-field cc-inline">
                <label className="cc-checkbox">
                  <input
                    type="checkbox"
                    checked={forceCityBounds}
                    disabled={!citySelected}
                    onChange={(e) => this.setState({ forceCityBounds: e.target.checked })}
                  />
                  <span>Forzar resultados dentro de la ciudad</span>
                </label>
              </div>

              {/* Tipo dirección */}
              <div className="cc-field">
                <label>Tipo de dirección</label>
                <select
                  disabled={!citySelected}
                  className="cc-input"
                  value={this.state.addressType}
                  onChange={(e) => this.setState({ addressType: e.target.value }, this.emitPayload)}
                >
                  {ADDRESS_TYPES.map(t => (
                    <option key={t.value} value={t.value}>{t.label}</option>
                  ))}
                </select>
              </div>

              {/* Tipo vivienda */}
              <div className="cc-field">
                <label>Tipo de vivienda</label>
                <select
                  disabled={!citySelected}
                  className="cc-input"
                  value={this.state.viviendaType}
                  onChange={(e) => this.setState({ viviendaType: e.target.value }, this.emitPayload)}
                >
                  <option value="casa">Casa</option>
                  <option value="edificio">Edificio / Conjunto</option>
                </select>
              </div>
            </div>

            {/* === FILA 2 === */}
            <div className="cc-filters">

              <div className="cc-field">
                <label>Dirección 1</label>
                <input
                  disabled={!citySelected}
                  className="cc-input"
                  placeholder="Calle principal y número"
                  value={this.state.direccion1}
                  onChange={(e) => {
                    const value = e.target.value;
                    this.setState({ direccion1: value }, () => {
                      const composite = this.buildCompositeAddress(value, this.state.direccion2);
                      this.setState({ address: composite });
                      if (this.autocompleteRef && this.autocompleteRef.handleInputChange) { 
                        const fakeEvent = { target: { value: composite } }; 
                        this.autocompleteRef.handleInputChange(fakeEvent); 
                      }
                    });
                  }}
                />
              </div>

              <div className="cc-field">
                <label>Dirección 2</label>
                <input
                  disabled={!citySelected}
                  className="cc-input"
                  placeholder="Intersección / Torre / Apto"
                  value={this.state.direccion2}
                  onChange={(e) => {
                    const value = e.target.value;
                    this.setState({ direccion2: value }, () => {
                      const composite = this.buildCompositeAddress(this.state.direccion1, value);
                      this.setState({ address: composite });
                      if (this.autocompleteRef && this.autocompleteRef.handleInputChange) { 
                        const fakeEvent = { target: { value: composite } }; 
                        this.autocompleteRef.handleInputChange(fakeEvent); 
                      }
                    });
                  }}
                />
              </div>

              {this.state.viviendaType === 'edificio' ? (
                <div className="cc-field">
                  <label>Depto / Piso</label>
                  <input
                    disabled={!citySelected}
                    className="cc-input"
                    placeholder="Torre B, Piso 9, Dpto 903"
                    value={this.state.aptOrFloor}
                    onChange={(e) =>
                      this.setState({ aptOrFloor: e.target.value }, () => {
                        const composite = this.buildCompositeAddress();
                        this.setState({ address: composite });
                      })
                    }
                  />
                </div>
              ) : (
                <div className="cc-field">
                  <label>Sector / Urbanización</label>
                  <input
                    disabled={!citySelected}
                    className="cc-input"
                    placeholder="La Floresta, Kennedy Norte, etc"
                    value={this.state.sector}
                    onChange={(e) =>
                      this.setState({ sector: e.target.value }, () => {
                        const composite = this.buildCompositeAddress();
                        this.setState({ address: composite });
                      })
                    }
                  />
                </div>
              )}

            </div>

            {/* === CAMPOS ESPECIALES PARA GUAYAQUIL === */}
            {this.state.cityCode === 'GYE' && (
              <div className="cc-filters">

                <div className="cc-field">
                  <label>Urbanización</label>
                  <input
                    disabled={!citySelected}
                    className="cc-input"
                    value={this.state.urbanizacion}
                    onChange={(e) => this.setState({ urbanizacion: e.target.value })}
                  />
                </div>

                <div className="cc-field">
                  <label>Etapa</label>
                  <input
                    disabled={!citySelected}
                    className="cc-input"
                    value={this.state.etapa}
                    onChange={(e) => this.setState({ etapa: e.target.value })}
                  />
                </div>

                <div className="cc-field">
                  <label>Manzana</label>
                  <input
                    disabled={!citySelected}
                    className="cc-input"
                    value={this.state.manzana}
                    onChange={(e) => this.setState({ manzana: e.target.value })}
                  />
                </div>

                <div className="cc-field">
                  <label>Villa</label>
                  <input
                    disabled={!citySelected}
                    className="cc-input"
                    value={this.state.villa}
                    onChange={(e) => this.setState({ villa: e.target.value })}
                  />
                </div>

              </div>
            )}

            {/* === FILA 3 === */}
            <div className="cc-filters">
              <div className="cc-field">
                <label>Entrega</label>
                <div className="cc-seg">
                  <button
                    type="button"
                    disabled={!citySelected}
                    className={`cc-seg-btn ${this.state.entregaModo === 'encuentro' ? 'active' : ''}`}
                    onClick={() => this.setState({ entregaModo: 'encuentro' }, this.emitPayload)}
                  >
                    Encuentro en la ubicación
                  </button>
                  <button
                    type="button"
                    disabled={!citySelected}
                    className={`cc-seg-btn ${this.state.entregaModo === 'puerta' ? 'active' : ''}`}
                    onClick={() => this.setState({ entregaModo: 'puerta' }, this.emitPayload)}
                  >
                    Dejar en la puerta
                  </button>
                  <button
                    type="button"
                    disabled={!citySelected}
                    className={`cc-seg-btn ${this.state.entregaModo === 'porteria' ? 'active' : ''}`}
                    onClick={() => this.setState({ entregaModo: 'porteria' }, this.emitPayload)}
                  >
                    Entregar en portería
                  </button>
                </div>
              </div>

              <div className="cc-field">
                <label>Referencia</label>
                <input
                  disabled={!citySelected}
                  className="cc-input"
                  placeholder="Casa azul, portón negro, junto al parque"
                  value={this.state.reference}
                  onChange={(e) =>
                    this.setState({ reference: e.target.value })
                  }
                />
              </div>
            </div>

            {/* === CAMPOS CONTACTO === */}
            <div className="cc-filters">

              <div className="cc-field">
                <label>Nombre de contacto</label>
                <input
                  disabled={!citySelected}
                  className="cc-input"
                  value={this.state.nombreContacto}
                  onChange={(e) => this.setState({ nombreContacto: e.target.value })}
                />
              </div>

              <div className="cc-field">
                <label>Teléfono de contacto</label>
                <input
                  disabled={!citySelected}
                  className="cc-input"
                  value={this.state.telefonoContacto}
                  onChange={(e) => {
                    const val = e.target.value;
                    const regex = /^09\d{8}$/;
                    this.setState({
                      telefonoContacto: val,
                      telefonoInvalido: !regex.test(val),
                    });
                  }}
                />
                {this.state.telefonoInvalido && (
                  <span style={{ color: 'red' }}>Debe ser un celular válido de Ecuador (09xxxxxxxx)</span>
                )}
              </div>

            </div>

            {/* === AUTOCOMPLETE === */}
            <PlacesAutocomplete
              ref={(ref) => (this.autocompleteRef = ref)}
              value={address}
              onChange={this.handleChange}
              onSelect={this.handleSelect}
              searchOptions={searchOptions}
              googleCallbackName="myCallbackFunc1"
              debounce={300}
              highlightFirstSuggestion
              shouldFetchSuggestions={shouldFetch}
            >
              {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <div className="cc-autocomplete">
                  <div className="cc-input-wrap">
                    <input
                      disabled={!citySelected}
                      {...getInputProps({
                        placeholder: 'Dirección exacta (Google)',
                        className: 'location-search-input cc-input cc-input-lg',
                        autoComplete: 'off',
                        onFocus: this.handleInputFocus,
                        onBlur: this.handleInputBlur,
                      })}
                    />
                  </div>

                  {this.state.isFocused && this.letterCount(address) < 7 && (
                    <div className="cc-hint">Escribe al menos 7 letras para ver sugerencias.</div>
                  )}

                  <div className="autocomplete-dropdown-container cc-suggestions">
                    {loading && <div className="cc-loading">Buscando direcciones…</div>}

                    {suggestions.map((sugg, idx) => {
                      const className = sugg.active ? 'suggestion-item--active' : 'suggestion-item';
                      const style = sugg.active
                        ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                        : { backgroundColor: '#fff', cursor: 'pointer' };

                      return (
                        <div
                          key={`${sugg.placeId || idx}`}
                          {...getSuggestionItemProps(sugg, { className, style })}
                          className={`cc-suggestion ${className}`}
                        >
                          <div className="cc-suggestion-main">
                            <span className="cc-suggestion-text">{sugg.description}</span>
                          </div>
                        </div>
                      );
                    })}

                    {!loading && suggestions.length === 0 && address && this.letterCount(address) >= 7 && (
                      <div className="cc-empty">No hay sugerencias.</div>
                    )}
                  </div>
                </div>
              )}
            </PlacesAutocomplete>

            {errorMsg && <div className="cc-error">{errorMsg}</div>}
          </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default locationSearchInput;
